module.exports = __webpack_public_path__ + "static/media/Avenir-Black.418bb51a.eot";